import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { SecurityLogForm as SecurityLogFormComponent } from '@ui/src';
import { clearLogPanelState } from './store/slices/logs';
import {
  useLazyGetLocksAuditLogItemQuery,
  useLazyGetLockItemUserQuery,
} from './store/services';

import ROUTES from '../../routes';

const SecurityLogForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();

  const [getLogItem, { isLoading, isFetching }] =
    useLazyGetLocksAuditLogItemQuery();
  const [getLockItemUser] = useLazyGetLockItemUserQuery();

  const {
    security: {
      logs: { logItem, logItemUser },
    },
    administrationDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  return (
    <SecurityLogFormComponent
      clearLogPanelState={() => dispatch(clearLogPanelState())}
      onClose={() => {
        navigate(`${ROUTES.SECURITY_LOGS}${search || ''}`);
      }}
      getLogItem={getLogItem}
      getLockItemUser={getLockItemUser}
      activePermissions={activePermissions}
      logItem={logItem}
      logItemUser={logItemUser}
      isLoading={isLoading}
      isFetching={isFetching}
    />
  );
};

export default SecurityLogForm;
